<template>
  <div class="container l28-tour-rank-wrap">
    <PageHeader style="margin:10px 0 0 0;"/>
    <div class="page_searcher">
      <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
    </div>
    <div>
      <div class="page_block">
        <h3>
          全天赛事成绩公告
          <a-button-group style="float:right; margin:0 0 0 10px" >
            <!-- <a-button @click="exportPng()"><a-icon type="download" />导出图片</a-button> -->
            <a-button id="copy-btn" @click="copyDiscord('all')"><a-icon type="copy"/>拷贝discord文案</a-button>
          </a-button-group>
        </h3>
        <div class="page_block_content" ref="captureRank">
          <div>
            <div class="item-tour" v-if="searchParams">
              <div class="p-header">{{searchParams.dt}}(GMT+0) Lucky Hero Tour Officials Result</div>
              <div v-for="race in listData" :key="race.score">
                <div class="p-item-title">---------- LEVEL {{race.score}} Competition ----------</div>
                  <div class="p-item-info" v-for="r in race.races" :key="r.tour_id">
                    <div class="race-name">{{r.tour_name}}: </div>
                    <div class="rank-list">
                      <div v-for="(n,idx) in r.topNameList" class="rank-item" :key="idx">
                        <img :class="`lvl-img`" :src="`${require(`@/assets/img/l28/tour-rank-${idx+1}.png`)}`" :onerror="noicon"/>
                        <!-- <img class="flag-img" src="https://ux.leihuo.netease.com/analyst/flag/CN.png" alt=""> -->
                        <span class="name">{{n.role_name}}<span v-if="n.country" class="app_flag" :style="`background: url(https://ux.leihuo.netease.com/analyst/flag/${n.country}.png);background-size:20px 16px;`"></span></span>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page_block">
        <h3>
          排行榜分析
          <a-button-group style="float:right; margin:0 0 0 10px" >
            <a-button id="copy-btn" @click="copyDiscord('top')"><a-icon type="copy"/>拷贝discord文案</a-button>
          </a-button-group>
        </h3>
        <div class="page_block_content" ref="captureRank">
          <div>
            <div class="item-tour" v-if="searchParams">
              <div class="p-header">{{searchParams.dt}}(GMT+0)  Top 10 lucky heroes of  the Lucky Hero Tour  are as follows:</div>
                <div class="p-item-info" v-for="(row,index) in topData[0]" :key="row.role_id">
                  <div class="race-name">   No.{{RANK_ICONS[index] }} {{ row.role_name?row.role_name:row.role_id }} {{ row.flag }},        points {{row.score}}!!! 
                  <span v-if="row.diff == 0">(🔸0)</span>
                  <span v-if="row.diff < 0">(🔺{{-row.diff}})</span>
                  <span v-if="row.diff > 0">(🔻{{row.diff}})</span>  ,
                  </div>
                </div>
              <p v-if="topData[1].length>0">Among them, the new heroes on the list are：<span v-for="row in topData[1]" :key="row.role_id">📢 {{ row.role_name }}, </span></p>
              <p>Congratulations to these lucky heroes！！！🎊 🎊 🎊 </p>
              <p>Finally, we hope you can have fun and achieve better results at the same time!! 🥳</p>
            </div>
          </div>
        </div>
      </div><div class="page_block">
        <h3>
          巡回赛日报
          <a-button-group style="float:right; margin:0 0 0 10px" >
            <a-button id="copy-btn" @click="copyDiscord('100')"><a-icon type="copy"/>拷贝discord文案</a-button>
          </a-button-group>
        </h3>
        <div class="page_block_content" ref="captureRank">
          <div>
            <div class="item-tour" v-if="searchParams">
              <div v-for="compete in competeData" :key="compete.id">
                <div class="p-header">{{searchParams.dt}}(GMT+0) Daily News:</div>
                <p>📢📢📢Three minutes a day, Get Cube Universe Tour events to know.</p>
                <p>Welcome to the daily news provided by "Lucky Heroes Home".</p>
                <div class="p-item-info" v-for="(player,pindex) in compete.players" :key="player.role_id">
                  <p v-if="pindex===0">Today our  hero "{{player.role_name}}"  won the {{compete.name }} point tour championship 🏆 🏆 🏆  with the 
                    <span v-for="(rank, ri) in player.rank_info" :key="ri">{{getRankStr(rank)}}{{`${ri>=2?'':', '}`}}</span> in the last three rounds.💯💯💯
                  </p>
                  <p v-else>"{{player.role_name}}" won the {{pindex===1?'runner-up':'second runner-up'}} with the 
                    <span v-for="(rank, ri) in player.rank_info" :key="ri">{{getRankStr(rank)}}{{`${ri>=2?'':', '}`}}</span> in the last three rounds.
                  </p>
                </div>
                <p>let's congratulate these three heroes.👏 👏 👏</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {ctrlMixin} from '@/utils/ctrlMixin.js';
import PageHeader from '@/components/game/pageheader.vue';
import Searcher from '@/components/common/search/searcher.vue';
import infiniteScroll from 'vue-infinite-scroll';
import _ from 'lodash';
import html2canvas from 'html2canvas';
import { domDownload } from '@/utils/common.js';
import Clipboard from 'clipboard';

const DISCORD_EMOJI = {
  1: ":first_place:",
  2: ":second_place:",
  3: ":third_place:"
}

const RANK_ICONS = ['🥇','🥈','🥉','4️⃣','5️⃣','6️⃣','7️⃣','8️⃣','9️⃣','🔟']
export default {
  mixins: [ctrlMixin],
  directives: { infiniteScroll },
  components: {
    Searcher,
    PageHeader
  },
  data() {
    return {
      datas:[[], [], []],
      loading: false,
      noicon: 'this.src="' + require("@/assets/img/allgame.png") + '"',
      RANK_ICONS,
      searchParams:{}
    }
  },
  computed: {
    tomorrow() {
      return moment(this.searchParams.dt).add(1, 'day').format('YYYY-MM-DD')
    },
    competeData() {
      const competeDict = {};
      (this.datas[2] || []).forEach(row=>{
        const tour_id = row.tour_id
        if(!competeDict[tour_id]) {
          competeDict[tour_id] = {id:tour_id, name: row.tour_name, players: [{}, {}, {}]}
        }
        if(row.group_rank <= 3) {
          competeDict[tour_id].players[row.group_rank-1] = {...row, rank_info: JSON.parse(row.rank_info)}
        }
      })
      const competeList = []
      Object.keys(competeDict).forEach(c=>{
        competeList.push(competeDict[c])
      })
      return competeList
    },
    topData() {
      const newtopData = [];
      const newin  = [];
      (this.datas[1] || []).forEach(row=>{
        row.diff = row.pre_rank!=null?row.current_rank - row.pre_rank:-row.current_rank
        row.flag = this.getFlagEmoji(row.country)
        if(row.pre_rank == null || row.pre_rank>10) {
          newin.push(row)
        }
        newtopData.push(row)
      })
      return [newtopData, newin]
    },
    listData() {
      const tmp = {};
      const result = [];
      (this.datas[0] || []).forEach(d => {
        const [, a0, a1] = (d.tour_name).match(/([^\d]*)(\d+)$/);
        const raceName = _.isNil(a0) ? '' : a0.trim();
        const raceScore = _.isNil(a1) ? 0 : +a1;
        const topNameList = [{
          role_name: d.role_name,
          group_rank: d.group_rank,
          country: d.country,
          flag: this.getFlagEmoji(d.country)
        }]
        if (tmp[raceScore]) {
          const tar = tmp[raceScore].findIndex(v => v.tour_id === d.tour_id);
          if (tar !== -1) {
            if (tmp[raceScore][tar]) {
              const tmpSortNameList = [...tmp[raceScore][tar].topNameList, {
                role_name: d.role_name,
                group_rank: d.group_rank,
                country: d.country,
                flag: this.getFlagEmoji(d.country)
              }].sort((prev, next) => prev.group_rank - next.group_rank);
              tmp[raceScore][tar].topNameList = tmpSortNameList;
            } else {
            }
          } else {
            tmp[raceScore].push({
              ...d,
              raceName,
              raceScore,
              topNameList
            });
          }
        } else {
          tmp[raceScore] = [{
            ...d,
            raceName,
            raceScore,
            topNameList
          }]
        }
      });
      const tmpRacelist = [];
      Object.entries(tmp).forEach(([m2, n2]) => {
        const sortedRace = n2.sort((prev, next) => (moment(next.ts).isBefore(moment(prev.ts)) ? 1 : -1));
        tmpRacelist.push({
          score: +m2,
          races: sortedRace
        });
      })
      const sortedRaceList = tmpRacelist.sort((prev, next) => (next.score - prev.score));
      return sortedRaceList;
    }
  },
  methods: {
    getFlagEmoji(str) {
      if(str && str.length == 2) {
        return `${String.fromCodePoint(str[0].codePointAt()-0x41+0x1F1E6)}${String.fromCodePoint(str[1].codePointAt()-0x41+0x1F1E6)}`
      }
      return str
    },
    getRankStr(rank) {
      switch(rank) {
        case 1: return '1st';
        case 2: return '2nd';
        case 3: return '3rd';
        default: return `${rank}th`;
      }
    },
    getData(params) {
      this.loading = true
      this.searchParams = params;
      this.$service.query(this.queryId, params).then((data)=>{
        this.datas = data
        this.loading = false
      }).catch((data)=> {
        this.loading = false
      })
    },
    getNames(name) {
      const res = [];
      const regex = /(\d+):(\w+)/g;
      let matches;
      while ((matches = regex.exec(name)) !== null) {
        const num = matches[1];
        const name = matches[2];
        res.push(name);
      }
      return res;
    },
    exportPng() {
      html2canvas(this.$refs.captureRank).then(canvas => {
        domDownload(canvas.toDataURL(), `tour-result.png`)
      })
    },
    copyDiscord(type) {
      const textList = [];
      if(type === 'all') {
        textList.push(`${this.searchParams.dt}(GMT+0) Lucky Hero Tour Officials Result \n`);
        let long_name_len = 0
        let long_com_name_len = 0
        this.listData.forEach(race => {
          if (race.score >= 50) {
            race.races.forEach(r => {
              if(r.raceName.length > long_com_name_len) {
                long_com_name_len = r.tour_name.length
              }
              r.topNameList.forEach((tn, idx) => {
                if(tn.role_name.length > long_name_len) {
                  long_name_len = tn.role_name.length
                }
              })
            })
          }
        })
        this.listData.forEach(race => {
          if (race.score >= 50) {
            textList.push(`\n---------- LEVEL ${race.score} Competition ----------`);
            race.races.forEach(r => {
              const tmpRanks = [];
              let _racename = `${r.tour_name}:`
              if(r.tour_name.length < long_com_name_len) {
                for(let i=0; i<(long_com_name_len-r.tour_name.length)*2; i++) {
                  _racename+=' '
                }
              }
              tmpRanks.push(_racename);
              r.topNameList.forEach((tn, idx) => {
                let txt = `${DISCORD_EMOJI[idx+1] || ''}${tn.role_name} ${tn.flag?tn.flag:''}`
                if(tn.role_name.length < long_name_len) {
                  for(let i=0; i<(long_name_len-tn.role_name.length)*2; i++) {
                    txt+=' '
                  }
                }
                tmpRanks.push(txt);
              });
              textList.push(`${tmpRanks.join('\t')}`);
            })
          }
        })
      }
      else if(type === 'top') {
        textList.push(`${this.searchParams.dt}(GMT+0) Top 10 lucky heroes of  the Lucky Hero Tour  are as follows: \n`);
        this.topData[0].forEach((row,index)=>{
          textList.push(`No.${RANK_ICONS[index] } ${ row.role_name?row.role_name:row.role_id } ${row.flag},        points ${row.score}!!!\
          ${row.diff == 0?'(🔸0)':row.diff > 0?`(🔻${row.diff})`:`(🔺${-row.diff})`}, `) 
        })
        if(this.topData[1].length > 0) {
          let news = 'Among them, the new heroes on the list are：'
          this.topData[1].forEach(row=>{
            news+=`📢 ${row.role_name}, `
          })
          textList.push(news)
        }
        textList.push('Congratulations to these lucky heroes！！！🎊 🎊 🎊 \n')
        textList.push('Finally, we hope you can have fun and achieve better results at the same time!! 🥳')
      }
      else if(type === '100') {
        this.competeData.forEach(compete=>{
          textList.push(`${this.searchParams.dt}(GMT+0) Daily News: \n`);
          textList.push('📢📢📢Three minutes a day, Get Cube Universe Tour events to know.');
          textList.push('Welcome to the daily news provided by "Lucky Heroes Home".');
          compete.players.forEach((player, pindex)=>{
            if(pindex===0) {
              textList.push(`Today our  hero "${player.role_name}"  won the ${compete.name} point tour championship 🏆 🏆 🏆  with the ${player.rank_info.map(r=>this.getRankStr(r)).join(', ')} in the last three rounds.💯💯💯`)
            }
            else {
              textList.push(`"${player.role_name}" won the ${pindex===1?'runner-up':'second runner-up'} with the ${player.rank_info.map(r=>this.getRankStr(r)).join(', ')} in the last three rounds.`)
            }
          })
          textList.push("let's congratulate these three heroes.👏 👏 👏")
          textList.push(`\n`);
        })
      }
      const clipboard = new Clipboard('#copy-btn', {
        text: () => textList.join(`\n`),
      });
      clipboard.on('success', e => {
        this.$message.success('复制成功');
        // 释放内存
        clipboard.destroy()
      });
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.success('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      });
    }
  }
}
</script>

<style lang="less">
.l28-tour-rank-wrap {
  .p-header {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 12px;
  }
  .p-item-title {
    font-weight: bold;
    padding: 8px 0;
  }
  .p-item-info {
    display: flex;
    align-items: center;
    padding: 2px 0;
    .rank-list {
      display: flex;
      align-items: center;
    }
    .race-name {
      min-width: 86px;
    }
    .rank-item {
      display: flex;
      align-items: center;
      padding-left: 6px;
    }
    .lvl-img {
      width: 26px;
      height: 26px;
    }
    .name {
      padding: 0 4px;
      min-width: 120px;
    }
    .flag-img {
      width: 18px;
      height: 12px;
      margin: 0 4px;
    }
  }
}

.app_flag {
      width: 20px;
      height: 16px;
      display: inline-block;
      margin:0 10px 0 10px;
      vertical-align: middle;
  }
</style>